<div class="body" [formGroup]="form">
  <div class="first-field">
    <button
      *ngIf="showDeleteButton"
      mat-icon-button
      class="tw-bg-red-500 hover:tw-bg-red-700"
      (click)="removeMeasureForm()"
    >
      <mat-icon class="tw-text-white">delete</mat-icon>
    </button>
    <mat-form-field
      [class]="showDeleteButton ? 'tw-col-span-3' : 'tw-col-span-4'"
      appearance="fill"
    >
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="type">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchType"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let measureType of measureTypesSelectable$ | async"
          [value]="measureType.title"
        >
          {{ measureType.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="dialogData?.toolTypes?.length > 0"
      appearance="fill"
      class="tw-col-span-4"
    >
      <mat-label>Herramienta</mat-label>
      <mat-select formControlName="toolType">
        <mat-option [value]="undefined">N/A</mat-option>
        <mat-option *ngFor="let tool of dialogData.toolTypes" [value]="tool.id">
          {{ tool.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Min</mat-label>
    <input matInput min="0" type="number" formControlName="min"/>
    <mat-error
      class="warning-message"
      *ngIf="form.get('min').errors?.['required']"
    >Valor mínimo requerido
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Nom</mat-label>
    <input matInput min="0" type="number" formControlName="expected"/>
    <mat-error
      class="warning-message"
      *ngIf="form.get('expected').errors?.['required']"
    >Valor esperado requerido
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Max</mat-label>
    <input matInput min="0" type="number" formControlName="max"/>
    <mat-error
      class="warning-message"
      *ngIf="form.get('max').errors?.['required']"
    >Valor máximo requerido
    </mat-error>
  </mat-form-field>
  <mat-form-field
    *ngIf="showTimesToMeasure"
    appearance="fill"
  >
    <mat-label>Numero de veces a medir</mat-label>
    <input matInput formControlName="timesToMeasure" type="number"/>
  </mat-form-field>
</div>

<!--    <ng-container-->
<!--      *ngFor="let measure of formMeasures.controls; let i = index"-->
<!--      formArrayName="measureValues"-->
<!--    >-->
<!--      <div class="all-numeric-data" [formGroupName]="i">-->
<!--        <div class="tw-flex tw-flex-row tw-border-r-2 tw-border-black">-->
<!--          <div class="tw-basis-1/4" *ngIf="i > 0">-->
<!--            <button-->
<!--              mat-icon-button-->
<!--              class="tw-bg-red-500 hover:tw-bg-red-700"-->
<!--              (click)="removeMeasureForm(i)"-->
<!--            >-->
<!--              <mat-icon>delete</mat-icon>-->
<!--            </button>-->
<!--          </div>-->
<!--          <mat-form-field-->
<!--            appearance="fill"-->
<!--            [ngClass]="i === 0 ? '' : 'tw-basis-3/4'"-->
<!--          >-->
<!--            <mat-label>Tipo</mat-label>-->
<!--            <mat-select formControlName="type">-->
<!--              <mat-option-->
<!--                *ngFor="let measureType of measureTypes"-->
<!--                [value]="measureType.title"-->
<!--              >-->
<!--                {{ measureType.title }}-->
<!--              </mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--        <mat-form-field appearance="fill">-->
<!--          <mat-label>Min</mat-label>-->
<!--          <input matInput min="0" type="number" formControlName="min" />-->
<!--          <mat-error-->
<!--            class="warning-message"-->
<!--            *ngIf="measure.get('min').errors?.['required']"-->
<!--            >Valor mínimo requerido-->
<!--          </mat-error>-->
<!--        </mat-form-field>-->
<!--        <mat-form-field appearance="fill">-->
<!--          <mat-label>Nom</mat-label>-->
<!--          <input matInput min="0" type="number" formControlName="expected" />-->
<!--          <mat-error-->
<!--            class="warning-message"-->
<!--            *ngIf="measure.get('expected').errors?.['required']"-->
<!--            >Valor esperado requerido-->
<!--          </mat-error>-->
<!--        </mat-form-field>-->
<!--        <mat-form-field appearance="fill">-->
<!--          <mat-label>Max</mat-label>-->
<!--          <input matInput min="0" type="number" formControlName="max" />-->
<!--          <mat-error-->
<!--            class="warning-message"-->
<!--            *ngIf="measure.get('max').errors?.['required']"-->
<!--            >Valor máximo requerido-->
<!--          </mat-error>-->
<!--        </mat-form-field>-->
<!--      </div>-->
<!--    </ng-container>-->
